import { Component } from 'vue-property-decorator';
import AbstractView from '@/views/abstract-view';
import EventBus from '@vertical-plus/vue-js-core/dist/util/event/event-bus';
import MeetingDataTableReport from '@/model/service/job/report/meeting-data-table-report';
import Techspec from '@/model/entity/job/techspec';
import TechspecService from '@/model/service/job/techspec-service';

@Component
export default class MeetingIndexView extends AbstractView
{
    protected report: MeetingDataTableReport|null = null;

    protected get title(): string
    {
        return this.$t('navbar.message.meetings').toString();
    }

    protected created()
    {
        this.report = new MeetingDataTableReport(this.$serviceContainer);
    }

    /**
     * Handles new meeting requests
     */

    private onNewMeeting()
    {
        EventBus.instance.$emit('create-meeting');
    }

    /**
     * Returns a human readable version of the meeting location
     *
     * @param techspec
     */

    private getMeetingLocation(techspec: Techspec): string
    {
        return TechspecService.getMeetingLocation(techspec);
    }
}